module.exports = __webpack_public_path__ + "static/pid-ug-8-en-howtouseauthcode-209257fd6cd1f12c4d82536991e80458.png";